import { router } from "../App";

/**
 * Navigates to a new path and provides centralized feedback.
 * @param path The destination path to navigate to.
 * @param options Standard React Router navigation options, plus a custom 'debug' flag.
 * @param options.replace - If true, the new entry will replace the current one in the history stack.
 * @param options.state - State to be associated with the new history entry.
 * @param options.debug - If true (default), logs success messages to the console. Failure messages are always logged.
 */
export async function navigate(
    path: string,
    options?: {
        replace?: boolean;
        state?: any;
        debug?: boolean;
    }
) {
    const { debug = true, ...routerOptions } = options ?? {};

    if (debug) {
        console.log(`[NavigationService] Attempting navigation to '${path}' with options:`, routerOptions);
    }

    if (!router?.navigate) {
        console.error(`[NavigationService] Router not initialized or navigate function not available.`);
        return;
    }

    try {
        await router.navigate(path, routerOptions);

        if (debug) {
            console.log(`[NavigationService] Successfully navigated to '${path}'.`);
            console.log("[NavigationService] Router state after success:", {
                currentLocation: router.state.location
            });
        }
    }
    catch (error) {
        console.error(`[NavigationService] Failed to navigate to '${path}'.`, error);
        console.error("[NavigationService] Router state after failure:", {
            currentLocation: router.state.location
        });
    }
}